import ProviderLead from "models/ProviderLead";
import Project from "models/Project";
import type { ProjectProductT } from "lib/misc/projectProducts";

type ProductVisionReasonsT = {
  visionProposalNonrequestableReasons?: Partial<Record<ProjectProductT, string | null>>;
};

type VisionDetailsT = (ProviderLead["props"] | Project["props"]) & ProductVisionReasonsT;

export const VISION_REASON_CHECKS: Record<string, (reason: string | null | undefined) => boolean> = {
  proposal_request_in_progress: (reason) => reason !== "proposal_request_in_progress",
  outside_vision_regions: (reason) => reason !== "outside_vision_regions",
  already_requested: (reason) => reason !== "already_requested",
};

const visionReasonFor = (details: VisionDetailsT, product?: ProjectProductT) => {
  const productReasons = details.visionProposalNonrequestableReasons;
  if (product && productReasons && product in productReasons) return productReasons[product];
  return details.visionProposalNonrequestableReason;
};

export const canSendVision = (
  details: VisionDetailsT,
  product?: ProjectProductT,
): [true, undefined] | [false, string] => {
  let canSend = true;
  const reasons: string[] = [];
  const reason = visionReasonFor(details, product);
  Object.entries(VISION_REASON_CHECKS).forEach(([message, checker]) => {
    const pass = checker(reason);
    if (!pass) {
      canSend = false;
      reasons.push(message);
    }
  });
  if (canSend) {
    return [true, undefined];
  }

  return [false, reasons[0]];
};
